module.exports = __webpack_public_path__ + "img/1.11277224.jpg";